import { render, staticRenderFns } from "./goodssalereturndetails.vue?vue&type=template&id=15cffbf8&scoped=true&"
import script from "./goodssalereturndetails.vue?vue&type=script&lang=js&"
export * from "./goodssalereturndetails.vue?vue&type=script&lang=js&"
import style0 from "./goodssalereturndetails.vue?vue&type=style&index=0&id=15cffbf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cffbf8",
  null
  
)

export default component.exports